import styles from "./Footer.module.css";

export function Footer() {
  return (
    <footer className={styles.foot}>
      <div className={styles.inner}>
        <p className={styles.mark}>MONDRAGÓN</p>
        <p className={styles.oath}>
          By reading this website and this text, you hereby acknowledge that I am the greatest
          Mondragón fan.
        </p>
        <p>
          Unofficial fan archive. Girls’ Frontline © Mica Team. Battlefield 1 M1908 conversion by{" "}
          <a href="https://x.com/SoupLord42" target="_blank" rel="noreferrer">
            @SoupLord42
          </a>
          . Chibi playback uses the Spine 2.1 reader from{" "}
          <a href="https://github.com/naganeko/naganeko-tools">naganeko-tools</a> (GPL-3.0). Dinergate
          Spine from{" "}
          <a href="https://iopwiki.com/wiki/Dinergate">IOP Wiki</a>. Rifle history compiled from{" "}
          <a href="https://en.wikipedia.org/wiki/Mondrag%C3%B3n_rifle">Wikipedia (CC BY-SA)</a>
          , including{" "}
          <a href="https://en.wikipedia.org/wiki/Mondrag%C3%B3n_rifle#Use_during_the_Mexican_Revolution">
            Use during the Mexican Revolution
          </a>{" "}
          (Edwards, <cite>Guns</cite> 1958; plates in <cite>Crónica Ilustrada Revolución Mexicana</cite>,
          Vol. 1, pp. 100 and 159),{" "}
          <a href="https://iopwiki.com/wiki/Mondragon">IOP Wiki</a>, and{" "}
          <a href="https://www.rockislandauction.com/detail/73/3380/sig-mondragon-model-1894-rifle-sn-2-sig-1894">
            Rock Island Auction (SIG Mondragón Model 1894, SN 2)
          </a>
          . Production counts that disagree are shown as ranges, not as a single invented figure.
          Non-commercial.
        </p>
        <p>
          Historical notes on Mexican ammunition quality and German aviation issue follow{" "}
          <a href="https://www.forgottenweapons.com/m1908-mondragon-semiauto-rifle-at-ria/">
            Ian McCollum / Forgotten Weapons
          </a>
          :{" "}
          <a href="https://www.forgottenweapons.com/mondragon-1908-semiauto-rifles-4-different-examples-video/">
            four M1908 examples
          </a>
          ,{" "}
          <a href="https://www.forgottenweapons.com/early-semiauto-rifles/mexican-mondragon/">
            Mexican Mondragón
          </a>
          . Quotes and voicelines from{" "}
          <a href="https://iopwiki.com/wiki/Mondragon/Quotes">Mondragon/Quotes</a>.
        </p>
      </div>
    </footer>
  );
}
